import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { modelUtils } from '@/utils'
const { WizForm } = component_tool
const { WizContainer } = framework_tool
const { isType } = utils_tool
import WizTableForm from '@/containers/common/wizTableForm/wizTableForm'
import teacherConfig from './config-teacher'

const dealerConfig = WizTableForm.Config.organizationBrandNode(this, { apiParams: { state: 1, organizationNodeCategory: [4] } })

class Editor extends WizContainer {

    componentName = 'Editor'

    constructor(props) {
        super(props)
        this.state = {
            timestamp: new Date().getTime()
        }
    }

    _ok = () => {
        this.refs.form.validateFields((err, values) => {
            if (!err) {
                let { id, orgId, moduleType, onlineTime, teachers } = values
                let params = {
                    id,
                    orgId,
                    moduleType,
                    onlineTime: onlineTime.format('YYYY-MM-DD 00:00:00'),
                    teachers
                }
                let action = id ? 'update' : 'add'
                this.doAction({
                    path: 'integrationCounseling/' + action,
                    payload: {
                        key: 'integrationCounseling@save',
                        apiParams: params
                    }
                })
            }
        })
    }

    propsAndStateOnChange = {
        save: this._saveOnChange.bind(this)
    }

    _saveOnChange(nextProps, nextState) {
        if (nextProps.save.code === 1) {
            wizNotice.success('操作成功')
            this.props.changeModal(false)
            let { editorSuccess } = this.props
            editorSuccess && editorSuccess()
        } else {
            wizNotice.error(nextProps.save.msg)
        }
    }

    render() {
        const { record = {} } = this.props
        let flag = record.teacherList && record.teacherList.length
        const columns = [{
            name: 'id',
            dataIndex: 'id',
            formItem: {
                type: 'hidden'
            }
        }, {
            title: '经销商名称',
            name: 'orgId',
            dataIndex: 'orgId',
            formItem: {
                ...dealerConfig,
                disabled: record.id ? true : false,
                initialValue: record.orgId,
                initRows: [{ id: record.orgId, name: record.orgName }],
                diy: WizTableForm,
                selectType: 'radio',
                placeholder: '请选择经销商',
                onChangeRowMap: data => {
                    if (data && isType(data, 'Object')) {
                        for (let [key, value = {}] of Object.entries(data)) {
                            let {
                                preSalesNumber = '',
                                afterSalesNumber = '',
                                address = ''
                            } = value
                            this.refs.form && this.refs.form.setFieldsValue({
                                preSalesNumber,
                                afterSalesNumber,
                                address
                            })
                        }
                    }
                },
                rules: [{ required: true, message: '请选择经销商' }]
            }
        }, {
            title: '销售代码',
            name: 'preSalesNumber',
            dataIndex: 'preSalesNumber',
            formItem: {
                placeholder: ' ',
                disabled: true
            }
        }, {
            title: '售后代码',
            name: 'afterSalesNumber',
            dataIndex: 'afterSalesNumber',
            formItem: {
                placeholder: ' ',
                disabled: true
            }
        }, {
            title: '经销商地址',
            name: 'address',
            dataIndex: 'address',
            formItem: {
                placeholder: ' ',
                disabled: true
            }
        }, {
            title: '辅导模块',
            name: 'moduleType',
            dataIndex: 'moduleType',
            dict: [
                { code: 0, codeName: '销售' },
                { code: 1, codeName: '售后' }
            ],
            formItem: {
                type: 'select',
                disabled: record.id ? true : false,
                rules: [{ required: true, message: '请选择辅导模块' }]
            }
        }, {
            title: '上线日期',
            name: 'onlineTime',
            dataIndex: 'onlineTime',
            formItem: {
                type: 'date',
                rules: [{ required: true, message: '请选择上线日期' }]
            }
        }, {
            title: '辅导老师',
            name: 'teachers',
            dataIndex: 'teachers',
            formItem: {
                links: { orgId: '经销商' },
                ...teacherConfig,
                initialValue: flag ? record.teachers : [],
                initRows: flag ? record.teacherList : [],
                diy: WizTableForm,
                selectType: 'checkbox',
                rules: [{ required: true, message: '请选择辅导老师' }]
            }
        }]
        const formProps = {
            key: record.id || this.state.timestamp,
            ref: 'form',
            columns,
            record,
            preview: false,
            footer: <div />,
            formItemLayout: {
                labelCol: { span: 4 },
                wrapperCol: { span: 17 }
            }
        }

        return <WizForm {...formProps} />
    }
}

const mapStateToProps = (state, ownProps) => {
    const { integrationCounseling } = state
    const save = modelUtils.getModelEntity(integrationCounseling, 'integrationCounseling@save')
    return {
        save
    }
}

const options = { withRef: true }

export default connect(mapStateToProps, null, null, options)(Editor)


